import { Suspense } from 'react';

import Config from '@config';
import {
  ConfirmProvider,
  I18nProvider,
  initI18nInstance,
} from '@gasbi/shared/common/providers';
import { NotificationProvider } from '@gasbi/shared/common/providers/NotificationProvider';
import { ErrorBoundary } from '@gasbi/shared/web/components/ErrorBoundary';
import { ThemeProvider } from '@gasbi/shared/web/providers/ThemeProvider';
import { ClickScrollPlugin, OverlayScrollbars } from 'overlayscrollbars';
import 'overlayscrollbars/overlayscrollbars.css';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';

import AuthProvider from '@/providers/AuthProvider';
import { SignalRProvider } from '@/providers/SignalRProvider';

import { LicenseInfo } from '@mui/x-license';

import { APP_REFRESH_ID } from './app/constants';
import store from './app/store';
import { i18nInstanceOptions } from './locales';
import { getRoutes } from './route';
import './styles/inter-font.css';

LicenseInfo.setLicenseKey(Config.VITE_MUI_LICENSE);

OverlayScrollbars.plugin(ClickScrollPlugin);

localStorage.setItem(APP_REFRESH_ID, Date.now().toString());

initI18nInstance(i18nInstanceOptions).then(i18n => {
  createRoot(document.getElementById('root')!).render(
    <ErrorBoundary>
      <I18nProvider instance={i18n}>
        <Provider store={store}>
          <ThemeProvider>
            <AuthProvider>
              <Suspense>
                <NotificationProvider>
                  <ConfirmProvider>
                    <SignalRProvider>
                      <RouterProvider router={getRoutes()} />
                    </SignalRProvider>
                  </ConfirmProvider>
                </NotificationProvider>
              </Suspense>
            </AuthProvider>
          </ThemeProvider>
        </Provider>
      </I18nProvider>
    </ErrorBoundary>,
  );
});

